import { FC, ReactNode } from 'react'
import { MenuAvatar, MenuAvatarType } from './Avatar'
import { MenuCard, MenuCardType } from './Card'
import { MenuOption, MenuOptionType } from './Option'

const Menu: FC &
  MenuAvatarType &
  MenuOptionType &
  MenuCardType = (): ReactNode => <></>

Menu.Avatar = MenuAvatar
Menu.Option = MenuOption
Menu.Card = MenuCard
export default Menu
